<style scoped>
img {
  width:60%

}

</style>

<template>
  <v-stepper 
    alt-labels
    v-model="step" 
    style="height:100%;overflow-y:scroll;overflow-x:scroll;" 
    class="elevation-0">
    <v-stepper-header>
      <v-stepper-step  step="1">Device parameters</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step  step="2">Register device</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step  step="3">WiFi Credentials</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step  step="4">Reboot device</v-stepper-step>
      <v-divider></v-divider>
    </v-stepper-header>

    <v-stepper-items class="text-xs-left subheading">
      <v-btn fab dark color="#FFD300" style="color:#002052;position:absolute;right:0;margin-top:1.5rem;z-index:10" @click="step++; step = (step==5)?1:step">
        <v-icon dark>fast_forward</v-icon>
      </v-btn>
      <v-btn fab dark color="#FFD300" style="color:#002052;position:absolute;right:0;bottom:0;z-index:10" @click="step++; step = (step==5)?1:step">
        <v-icon dark>fast_forward</v-icon>
      </v-btn>
      <v-stepper-content step="1" >
        <v-card>
          <v-card-title  style="background-color:#39a9dc">
            <h2 class="title white--text font-weight-light">Get ID and certificate</h2>
          </v-card-title>
          <v-container>
              <v-layout row wrap>
                <v-flex xs12>
                <b>a</b>. Connect device to the PC via USB, flash FP-CLD-AWS1v3 binary file and reboot. In case of STWIN device, before flash it and then connect via USB.
                </v-flex>
                <v-flex xs12>
                <b>b</b>. Open serial terminal (e.g. TeraTerm) to inspect device log
                </v-flex>
                <v-flex xs12>
                  <img src="@/assets/howto/serialportsetup.png" />
                </v-flex>
                <v-flex xs12>
                <b>c</b>. Copy <b>PEM string certificate</b> and <b>device ID</b>
                <v-flex xs12>
                  <img src="@/assets/howto/wificredentials.png" />
                </v-flex>
                </v-flex>
              </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-card>
          <v-card-title   style="background-color:#39a9dc">
            <v-icon
              class="mr-3"
              dark
              size="42"
            >
              mdi-email-outline
            </v-icon>
            <h2 class="title white--text font-weight-light">Register device</h2>
          </v-card-title>
          <v-container>
            <v-layout row wrap>
                <v-flex xs12 >
                  Register device with:
                  <ul>
                    <li>human-friendly label</li>
                    <li>unique ID got from terminal</li>
                    <li><i>"multi-account registration"</i> option checked</li> (paste here PEM string)
                  </ul>
                </v-flex>
                <v-flex>
                  <img  src="@/assets/howto/registerwifidevice.png" />
                </v-flex>
              </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-card>
          <v-card-title   style="background-color:#39a9dc">
            <v-icon
              class="mr-3"
              dark
              size="42"
            >
              mdi-email-outline
            </v-icon>
            <h2 class="title white--text font-weight-light">Wifi credentils</h2>
          </v-card-title>
          <v-container>
            <v-layout row wrap>
                <v-flex xs12 >
                  Set device  WiFi credentials.
                </v-flex>
                <v-flex xs12>
                  <img src="@/assets/howto/wifiapcredentials.png" />
                </v-flex>
              </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="4">
        <v-card>
          <v-card-title   style="background-color:#39a9dc">
            <v-icon
              class="mr-3"
              dark
              size="42"
            >
              mdi-email-outline
            </v-icon>
            <h2 class="title white--text font-weight-light">Reboot device</h2>
          </v-card-title>
          <v-container>
            <v-layout row wrap>
                <v-flex xs12 >
                  Reboot device and start monitoring.
                </v-flex>
              </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(
      {
          http: state => state.metadata.backendApi.http[state.metadata.env]
      }
    )
  },
  data(){
    return {
      step: 0
    }
  }
}
</script>